import React from 'react';

function LatencyIndicator({ latency }) {
  let color = '#7f8c8d';
  if (latency == null) color = '#7f8c8d';
  else if (latency < 80) color = '#2ecc71';
  else if (latency <= 150) color = '#f1c40f';
  else color = '#e74c3c';

  const label =
    latency == null
      ? 'Unknown latency'
      : latency < 80
      ? `Excellent (${latency}ms)`
      : latency <= 150
      ? `Fair (${latency}ms)`
      : `Poor (${latency}ms)`;

  return (
    <span
      title={label}
      style={{
        display: 'inline-block',
        width: 10,
        height: 10,
        borderRadius: '50%',
        backgroundColor: color,
      }}
    />
  );
}

export default LatencyIndicator;
